module.exports = __webpack_public_path__ + "img/48-1100da.png";